class MattressExpertsQuotes extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    if (this.isConnected && !this.initialized) {
      this.initialized = true;
      this.waitForStylesheetAndLoad();
    }
  }

  waitForStylesheetAndLoad() {
    if (document.readyState == 'complete') {
      this.initSwiper();
    } else {
      window.addEventListener('load', () => {
        this.initSwiper();
      });
    }
  }

  initSwiper() {
    this.swiper = new Swiper('.ExpertsSlider', {
      slidesPerView: 1.2,
      initialSlide: 1,
      centeredSlides: true,
      spaceBetween: 10,
      threshold: 5,
      navigation: {
        nextEl: '.ExpertsSliderNav__Next',
        prevEl: '.ExpertsSliderNav__Prev',
      },
      pagination: {
        el: '.ExpertsSliderPagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
        },
        1107: {
          slidesPerView: 3,
          spaceBetween: 30,
        }
      },
    });
  }
}
customElements.define('mattress-experts-quotes', MattressExpertsQuotes);